const proposalEvaluationStatus = Object.freeze({
  Pendiente: 1,
  EnProcesoEvaluacion: 2,
  Evaluada: 3,
  Anulada: 4,
});

export default proposalEvaluationStatus;
